<template>
    <div class="form-group"  v-if="noWrapper">
    <multiselect :id="id"
                 ref = 'input'
                 :options="options"
                 :searchable="searchable"
                 :close-on-select="closeOnSelect"
                 label="text"
                 track-by="id"
                 :show-labels="showLabels"
                 :placeholder="placeholder !== '' ? placeholder : label"
                 :disabled="disabled"
                 @update:model-value="onChange"
                 v-bind="$attrs"
                 :multiple="multiple"
                 :taggable="taggable"
                 v-model="selectedValue">
    </multiselect>
    </div>
    <np-responsive v-else :split="split">
        <template #label><span>{{label}}</span></template>
        <template #input>
        <div class="form-group">
            <multiselect :id="id"
                         ref = 'input'
                         :options="options"
                         :searchable="searchable"
                         :close-on-select="closeOnSelect"
                         label="text"
                         :required="isRequired"
                         track-by="id"
                         :show-labels="showLabels"
                         :placeholder="placeholder !== '' ? placeholder : label"
                         @input="onChange"
                         v-bind="$attrs"
                         :multiple="multiple"
                         :taggable="taggable"
                         v-model="selectedValue">
            </multiselect>
        </div>
        </template>
    </np-responsive>
</template>

<script>
    import {Multiselect} from 'vue-multiselect';
    import NPResponsive from './np-responsive.vue';
    export default {
        name: "np-multiselect",
        components: {
            'multiselect': Multiselect,
            'np-responsive': NPResponsive,
        },
        props: {
            id: '',
            label: '',
            options: {
                type: Array,
                default: () => {
                    return []
                }
            },
            value: {},
            noWrapper: Boolean,
            split: Number,
            multiple: Boolean,
            searchable: Boolean,
            placeholder: String,
            closeOnSelect: {
                type: Boolean,
                default: () => {
                    return true;
                }
            },
            showLabels: Boolean,
            disabled: Boolean,
            modelValue: [String, Number]
        },
        data() {
            return {
                value: '',
                selectedValue: {},
                taggable: Boolean,
            }
        },
        computed: {
            select: function() {
                return this.$refs.input;
            },
            isRequired: function () {
                return this.check_config ? !!this.page_config_required : !!this.required;
            },
        },
        mounted(){
          this.init();
        },
        created() {
            // //TODO how to handle this if the options are not objects.
            // //console.log(this.$attrs.value)
            // //TODO  this.$attrs.value is undefined when mounted
            // this.selectedValue = this.options.find(o => o.id === this.$attrs.value)
            //
            // //if multiple is true, make taggable true
            // this.taggable = this.multiple;
        },
        methods: {
            //TODO need to add our np-validation-rules
            //TODO  this components needs to be receive the updated value programatically.
            init: function (){
                let vm = this;

                this.selectedValue = this.options.find(o => o.id === vm.value)

                //console.log(this.value)
                // this.$emit('input', vm.value);
                //if multiple is true, make taggable true
                this.taggable = this.multiple;
                if (vm.autoselect && vm.options.length == 1) {
                    this.setSingleParameter()
                }
            },
            setSingleParameter: function () {
                let vm = this;
                if (vm.modelValue !== vm.options[0].id) {
                    vm.$emit('update:modelValue', vm.options[0].id);
                }
            },
            onChange (value) {
                // this.value = value
                this.$emit('update:modelValue', value.id);
            },
        },
        watch: {
            modelValue: function (value) {
                //console.log(value)
                // update value
                this.selectedValue = val
            },
            // value (val){
            //     //console.log(val)
            //     this.selectedValue = val
            // }
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>